<template>
    <div class="login-box">
        <div class="login-logo">
            <b>Pam</b> Rapprochement
        </div>
        <!-- /.login-logo -->
        <div class="login-box-body">
            <p class="login-box-msg">Sign in to start your session</p>

            <form action="../../index2.html" method="post">
                <!--<div class="form-group has-feedback">
                    <input type="email" class="form-control" placeholder="Login" v-model="username">
                    <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">-->
                    <!--<input type="password" class="form-control" placeholder="Password" v-model="pwd">-->
                    <!--<span class="glyphicon glyphicon-lock form-control-feedback"></span>-->
                <!--</div>-->
                <div class="row">
                    <!-- /.col -->
                    <div class="col-2"></div>
                    <div class="col-8">
                        <button type="submit"
                                @click.prevent="login()"
                                class="btn btn-primary btn-block btn-flat"
                        >Sign In
                        </button>
                    </div>
                    <div class="col-2"></div>
                    <!-- /.col -->
                </div>
            </form>
        </div>
        <!-- /.login-box-body -->
    </div>
</template>

<script>
    import $ from 'jquery'
    import api from '../../resources/apiProvider'
    import 'admin-lte/dist/js/adminlte'
    //import Vue from 'vue'
    import localStorage from 'localStorage'
    import toastr from 'toastr/build/toastr.min'

    export default {
        mounted() {
            $('body').removeClass().addClass('login-page')
        },
        data () {
            return {
                url: process.env.VUE_APP_ROOT_API + '/' + api.getResourceUri().auth.auth
            }
        },
        methods: {
            login() {
                const vm = this
                // Open child window to log on ADFS
                vm.openPopUpWindow()
                // Listen to message from child window
                const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                const eventer = window[eventMethod];
                const messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
                eventer(messageEvent,function(event) {
                    if(event.data) {
                        const data = event.data
                        vm.authState(data.state, data.user, data.token)
                    }
                },false);
            },
            openPopUpWindow () {
                const vm = this
                const url = vm.url
                const width = 1000
                const height = 650
                const top = (window.outerHeight - height) / 2
                const left = (window.outerWidth - width) / 2
                window.open(url,
                    'facebook_login',
                    'width=' + width + ',height=' + height + ',scrollbars=0,top=' + top + ',left=' + left)
            },
            authState(state, user, token) {
                const vm = this
                const storeAuth = vm.$store.storeAuth
                if (state === 'failure') {
                    toastr.error("L'authentification a echoué.\n"
                        + "Veuillez recommencer ou contacter un administrateur.")
                    return
                }
                storeAuth.dispatch("setConnected", true)
                storeAuth.dispatch("setUser", user)
                storeAuth.dispatch("setToken", token)
                localStorage.setItem('token', token)
                $('body').removeClass().addClass('skin-purple sidebar-mini')
                location.reload()
            }

        },
        computed: {
            btnIsDisabled() {
                return this.username === '' || this.pwd === ''
            }
        }
    }
</script>


